/**
 * Smile Meta Product — Vanilla JS
 * Handles: inclusion selector, upsell card selection + bonus reveal,
 * ATC form, sticky ATC bar, accordions, bottom CTA passthrough.
 * No jQuery. No third-party libraries.
 * Runs after DOM is ready (loaded via defer in theme.smile.liquid).
 */

(function () {
  'use strict';

  // ─── Inclusion Selector ─────────────────────────────────────────────────

  var inclusionRadios = document.querySelectorAll('[data-inclusion-radio]');
  var inclusionProperty = document.getElementById('smile-inclusion-property');

  if (inclusionRadios.length && inclusionProperty) {
    inclusionRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        inclusionProperty.value = this.value;
        document.querySelectorAll('.sm-inclusion-card').forEach(function (card) {
          card.classList.remove('is-selected');
        });
        var parentCard = this.closest('.sm-inclusion-card');
        if (parentCard) {
          parentCard.classList.add('is-selected');
        }
      });
    });
  }


  // ─── Variant Selector ───────────────────────────────────────────────────

  var variantSelector = document.getElementById('smile-variant-selector');
  var variantIdInput = document.getElementById('smile-variant-id');
  var atcBtnEl = document.getElementById('smile-atc-btn');
  var variantsData = atcBtnEl ? JSON.parse(atcBtnEl.getAttribute('data-variants') || '[]') : [];
  var variantImageEl = document.getElementById('smile-product-image');

  function getSizedImageUrl(url, width) {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, function (match, ext, query) {
      return '_' + width + 'x' + ext + (query || '');
    });
  }

  // Track selected options — initialise from current button selected states
  var selectedOptions = {};
  if (variantSelector) {
    variantSelector.querySelectorAll('.sm-variant-btn.is-selected').forEach(function (btn) {
      var idx = btn.getAttribute('data-option-index');
      selectedOptions[idx] = btn.getAttribute('data-option-value');
    });
  }

  function findMatchingVariant() {
    return variantsData.find(function (variant) {
      var o1 = selectedOptions['0'] ? variant.option1 === selectedOptions['0'] : true;
      var o2 = selectedOptions['1'] ? variant.option2 === selectedOptions['1'] : true;
      var o3 = selectedOptions['2'] ? variant.option3 === selectedOptions['2'] : true;
      return o1 && o2 && o3;
    });
  }

  function getOptionKey(optionIndex) {
    return 'option' + (parseInt(optionIndex, 10) + 1);
  }

  // A value is available only if some variant exists carrying that value
  // AND matching every other currently-selected option (not just itself).
  function isValueAvailable(optionIndex, value) {
    return variantsData.some(function (variant) {
      if (variant[getOptionKey(optionIndex)] !== value || !variant.available) {
        return false;
      }
      return Object.keys(selectedOptions).every(function (otherIndex) {
        if (otherIndex === optionIndex || !selectedOptions[otherIndex]) return true;
        return variant[getOptionKey(otherIndex)] === selectedOptions[otherIndex];
      });
    });
  }

  function refreshButtonAvailability() {
    if (!variantSelector) return;
    variantSelector.querySelectorAll('.sm-variant-btn').forEach(function (btn) {
      var optionIndex = btn.getAttribute('data-option-index');

      // Index 0 (the primary selector, e.g. Strength) must always remain
      // clickable — it is never disabled based on the secondary selection.
      if (optionIndex === '0') {
        btn.classList.remove('is-unavailable');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        return;
      }

      var optionValue = btn.getAttribute('data-option-value');
      var available = isValueAvailable(optionIndex, optionValue);

      btn.classList.toggle('is-unavailable', !available);
      if (available) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function updateVariantState() {
    var matched = findMatchingVariant();
    if (!matched) return;

    // Update hidden variant ID input
    if (variantIdInput) variantIdInput.value = matched.id;

    // Update base price on ATC button for price calculation
    if (atcBtnEl) atcBtnEl.setAttribute('data-base-price', matched.price);

    // Update ATC button availability
    var atcLine1 = atcBtnEl ? atcBtnEl.querySelector('[data-atc-line1]') : null;
    if (matched.available) {
      if (atcBtnEl) atcBtnEl.removeAttribute('disabled');
      updateAtcButtonPrice();
    } else {
      if (atcBtnEl) atcBtnEl.setAttribute('disabled', 'disabled');
      if (atcLine1) atcLine1.textContent = 'Sold Out';
    }

    // Update sticky bar price
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) {
      stickyPrice.textContent = '$' + (matched.price / 100).toFixed(2);
    }

    // Update product image to match selected variant
    if (variantImageEl && matched.featured_image && matched.featured_image.src) {
      variantImageEl.src = getSizedImageUrl(matched.featured_image.src, 1600);
      variantImageEl.alt = matched.featured_image.alt || variantImageEl.alt;
    }
  }

  if (variantSelector) {
    refreshButtonAvailability();

    variantSelector.querySelectorAll('.sm-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionIndex = this.getAttribute('data-option-index');
        var optionValue = this.getAttribute('data-option-value');

        // Update selected state for this option group
        variantSelector.querySelectorAll('.sm-variant-btn[data-option-index="' + optionIndex + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        this.classList.add('is-selected');

        // Update label value display
        var labelValue = document.getElementById('smile-option-value-' + optionIndex);
        if (labelValue) labelValue.textContent = optionValue;

        // Store selection
        selectedOptions[optionIndex] = optionValue;

        // Recompute cross-combination availability for every other option group
        refreshButtonAvailability();

        // Update variant state
        updateVariantState();
      });
    });
  }


  // ─── Upsell Cards → Bonus Reveal ────────────────────────────────────────
  // Selecting an upsell card marks it active and reveals the bonus picker
  // (if present). Re-clicking toggles it off.

  var upsellCards = document.querySelectorAll('[data-upsell-card]');
  var upsellBonus = document.querySelector('[data-upsell-bonus]');
  var upsellProperty = document.getElementById('smile-upsell-property');

  function updateAtcButtonPrice() {
    var atcButton = document.getElementById('smile-atc-btn');
    if (!atcButton) return;
    var line1 = atcButton.querySelector('[data-atc-line1]');
    var basePrice = parseInt(atcButton.getAttribute('data-base-price'), 10) || 0;
    var upsellTotal = 0;
    Array.prototype.forEach.call(upsellCards, function (c) {
      if (c.classList.contains('is-selected')) {
        upsellTotal += parseInt(c.getAttribute('data-upsell-price'), 10) || 0;
      }
    });
    var total = basePrice + upsellTotal;
    // Format cents to currency string matching Shopify money format (e.g. $101.70)
    var formatted = '$' + (total / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (line1) {
      line1.textContent = 'Add to Cart — ' + formatted;
    }

    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) {
      stickyPrice.textContent = formatted;
    }
  }

  function refreshBonusVisibility() {
    if (!upsellBonus) return;
    var anySelected = document.querySelector('[data-upsell-card].is-selected');
    upsellBonus.classList.toggle('is-visible', !!anySelected);
  }

  upsellCards.forEach(function (card) {
    var btn = card.querySelector('[data-upsell-add]');
    if (!btn) return;

    var variantSelect = card.querySelector('[data-upsell-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selectedOption = this.options[this.selectedIndex];
        card.setAttribute('data-upsell-variant', this.value);
        var newPrice = parseInt(selectedOption.getAttribute('data-price'), 10) || 0;
        card.setAttribute('data-upsell-price', newPrice);
        updateAtcButtonPrice();
      });
    }

    btn.addEventListener('click', function () {
      var wasSelected = card.classList.contains('is-selected');
      card.classList.toggle('is-selected', !wasSelected);
      btn.textContent = wasSelected
        ? (btn.getAttribute('data-upsell-default-label') || 'Add to Order')
        : 'Added ✓';
      if (upsellProperty) {
        var selectedNames = Array.prototype
          .filter.call(upsellCards, function (c) { return c.classList.contains('is-selected'); })
          .map(function (c) { return c.getAttribute('data-upsell-name'); });
        upsellProperty.value = selectedNames.join(', ');
      }
      refreshBonusVisibility();
      updateAtcButtonPrice();
    });
  });


  // ─── Bonus Product Selection ─────────────────────────────────────────────

  var bonusRadios = document.querySelectorAll('[data-bonus-radio]');

  var selectedBonusVariantId = null;

  bonusRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      document.querySelectorAll('.sm-bonus-card').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      var parentCard = this.closest('.sm-bonus-card');
      if (parentCard) {
        parentCard.classList.add('is-selected');
        selectedBonusVariantId = parentCard.getAttribute('data-bonus-variant');
      }
      if (upsellProperty) {
        var selectedUpsellNames = Array.prototype
          .filter.call(upsellCards, function (c) { return c.classList.contains('is-selected'); })
          .map(function (c) { return c.getAttribute('data-upsell-name'); });
        var bonusLabel = this.value ? ' + Bonus: ' + this.value : '';
        upsellProperty.value = selectedUpsellNames.join(', ') + bonusLabel;
      }
    });
  });

  bonusRadios.forEach(function (radio) {
    if (radio.checked) {
      var parentCard = radio.closest('.sm-bonus-card');
      if (parentCard) {
        parentCard.classList.add('is-selected');
        selectedBonusVariantId = parentCard.getAttribute('data-bonus-variant');
      }
    }
  });


  // ─── Add to Cart Form ───────────────────────────────────────────────────

  var form = document.getElementById('smile-product-form');
  var atcBtn = document.getElementById('smile-atc-btn');

  function addToCartRequest(payload) {
    return fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Could not add to cart');
        });
      }
      return response.json();
    });
  }

  function submitAddToCart() {
    if (!form || !atcBtn) return;
    if (atcBtn.classList.contains('is-loading')) return;

    var variantId = form.querySelector('[name="id"]').value;
    if (!variantId) return;

    // Read inclusion-enabled flag from either the form attribute or the hidden input fallback
    var inclusionEnabledAttr = form.getAttribute('data-inclusion-enabled');
    var inclusionEnabledInput = form.querySelector('[data-inclusion-enabled]');
    var inclusionEnabled = inclusionEnabledAttr === 'true' ||
      (inclusionEnabledInput && inclusionEnabledInput.getAttribute('data-inclusion-enabled') === 'true');
    var inclusionValue = inclusionProperty ? inclusionProperty.value : '';

    var properties = {};
    if (inclusionEnabled && inclusionValue) {
      properties['Complimentary Inclusion'] = inclusionValue;
    }

    var selectedUpsellCards = Array.prototype.filter.call(
      upsellCards,
      function (c) { return c.classList.contains('is-selected'); }
    );

    atcBtn.classList.add('is-loading');
    var originalHTML = atcBtn.innerHTML;
    atcBtn.textContent = 'Adding…';

    var mainPayload = {
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: properties
    };

    var addChain = addToCartRequest(mainPayload);

    selectedUpsellCards.forEach(function (card) {
      var upsellVariantId = card.getAttribute('data-upsell-variant');
      if (!upsellVariantId) return;
      addChain = addChain.then(function () {
        return addToCartRequest({
          id: parseInt(upsellVariantId, 10),
          quantity: 1
        });
      });
    });

    if (selectedBonusVariantId) {
      addChain = addChain.then(function () {
        return addToCartRequest({
          id: parseInt(selectedBonusVariantId, 10),
          quantity: 1
        });
      });
    }

    addChain
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        atcBtn.classList.remove('is-loading');
        atcBtn.innerHTML = originalHTML;
        console.error('[Smile ATC]', err.message);
        form.submit();
      });
  }

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitAddToCart();
    });
  }


  // ─── Bottom CTA → triggers hero form submit ────────────────────────────

  var bottomCtaBtn = document.getElementById('smile-bottom-cta-btn');
  if (bottomCtaBtn) {
    bottomCtaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var hero = document.getElementById('sm-hero');
      if (hero) {
        hero.scrollIntoView({ behavior: 'smooth' });
      }
      var atcBtn = document.getElementById('smile-atc-btn');
      if (atcBtn) {
        setTimeout(function () { atcBtn.focus(); }, 600);
      }
    });
  }


  // ─── Sticky ATC Bar ─────────────────────────────────────────────────────

  var stickyBar = document.getElementById('smile-sticky-atc');
  var stickyBtn = document.getElementById('smile-sticky-atc-btn');

  if (stickyBar) {
    stickyBar.classList.add('is-visible');
    stickyBar.setAttribute('aria-hidden', 'false');
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }


  // ─── Accordion ──────────────────────────────────────────────────────────

  var accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(function (accordion) {
    var trigger = accordion.querySelector('.sm-accordion__trigger');
    var body = accordion.querySelector('.sm-accordion__body');
    if (!trigger || !body) return;

    // Honour server-rendered default-open state (FAQ when faq_default_open is true).
    if (trigger.getAttribute('aria-expanded') === 'true') {
      body.style.maxHeight = body.scrollHeight + 'px';
    }

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        body.style.maxHeight = '0';
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });


  // ─── Cart Count Update ──────────────────────────────────────────────────

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('c-site-header__cart-count--empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }


  // ─── Upsell Info Popup ───────────────────────────────────────────────────

  var popupOverlay = document.getElementById('smile-popup-overlay');
  var popupClose = document.getElementById('smile-popup-close');
  var popupTitle = document.getElementById('smile-popup-title');
  var popupBody = document.getElementById('smile-popup-body');

  function openPopup(title, content) {
    if (!popupOverlay || !popupTitle || !popupBody) return;
    popupTitle.textContent = title;
    popupBody.innerHTML = content;
    popupOverlay.classList.add('is-open');
    popupOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (popupClose) popupClose.focus();
  }

  function closePopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove('is-open');
    popupOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-popup-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var title = this.getAttribute('data-popup-title') || '';
      var content = this.getAttribute('data-popup-content') || '';
      openPopup(title, content);
    });
  });

  if (popupClose) {
    popupClose.addEventListener('click', closePopup);
  }

  if (popupOverlay) {
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closePopup();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popupOverlay && popupOverlay.classList.contains('is-open')) {
      closePopup();
    }
  });

})();
